export default __webpack_public_path__ + "static/media/netflix.3c3b8fdc.png";